'use client';

import ImageAdaptive from '@/components/ImageAdaptive';
import FormSectionTitle from '@/components/ui/form/FormSectionTitle';

export default function GearScoreExplanation() {
    const gearScoreList = [
        {
            title: '日常的／専門的',
            label1: '活用の領域',
            label2: '実用と技術',
            items: [
                {
                    imgSrc: '/images/gear/score/daily.svg',
                    title: '日常的',
                    description: '多くの人が日常的かつ汎用的に利用できるかについての評価です。',
                },
                {
                    imgSrc: '/images/gear/score/specialized.svg',
                    title: '専門的',
                    description: '特定の場面や専門分野で、特定のユーザーが利用可能かについての評価です。',
                },
            ],
        },
        {
            title: 'ソフトウェア／ハードウェア',
            label1: '仕組み',
            label2: '制御と構造',
            items: [
                {
                    imgSrc: '/images/gear/score/software.svg',
                    title: 'ソフトウェア',
                    description: '開発したプログラムやアプリケーションについての評価です。',
                },
                {
                    imgSrc: '/images/gear/score/hardware.svg',
                    title: 'ハードウェア',
                    description:
                        '設置場所の景観を損ねないか、破損や故障のリスクを減らすための工夫がされているかなど外部構造についての評価です。',
                },
            ],
        },
        {
            title: '革新的／一般的',
            label1: '発想の新規性',
            label2: '斬新と基本',
            items: [
                {
                    imgSrc: '/images/gear/score/innovation.svg',
                    title: '革新的',
                    description:
                        '開世の中にまだない新しいサービスやプロダクトを生み出したか、注目されていない課題を解決しているかについての評価です。',
                },
                {
                    imgSrc: '/images/gear/score/versatile.svg',
                    title: '一般的',
                    description:
                        '世の中にすでに存在するサービスやプロダクトを、自分の設定した課題に対して適切に活用できているかについての評価です。',
                },
            ],
        },
    ];

    return (
        <>
            <div className="flex flex-col justify-start items-start w-full h-full p-4 bg-color-white-base">
                <div className="flex flex-shrink-0 justify-center items-end font-montserrat font-black text-xl lg:text-3xl text-color-base tracking-wide w-full py-2 px-4">
                    eDIY SCORE
                </div>
                <div className="flex flex-col w-full">
                    {gearScoreList.map((score, index) => (
                        <GearScoreCateogries
                            key={index}
                            title={score.title}
                            label1={score.label1}
                            label2={score.label2}
                            items={score.items}
                        />
                    ))}
                </div>
            </div>
        </>
    );
}

type GearScoreCateogriesProps = {
    title: string;
    label1: string;
    label2: string;
    items: {
        imgSrc: string;
        title: string;
        description: string;
    }[];
};

function GearScoreCateogries({ title, label1, label2, items }: GearScoreCateogriesProps) {
    return (
        <div className="flex flex-col w-full h-full p-2 lg:p-4">
            <div className="flex flex-col lg:flex-row flex-shrink-0 justify-end lg:justify-start items-start lg:items-center font-corp text-color-base tracking-widest w-full pb-2 lg:pb-4">
                <div className="flex justify-start items-center font-bold text-base lg:text-xl lg:mx-4 py-2 lg:py-0">
                    <FormSectionTitle title={title} />
                </div>
                <div className="flex w-full lg:w-auto justify-end lg:justify-start font-medium">
                    <div className="flex-shrink-0 items-center text-xs text-color-white-base bg-color-base rounded-3xl mx-2 px-4 py-1">
                        {label1}
                    </div>
                    <div className="flex-shrink-0 items-center text-xs text-color-white-base bg-color-base rounded-3xl mx-2 px-4 py-1">
                        {label2}
                    </div>
                </div>
            </div>
            {items.map((item, index) => (
                <div key={index} className="flex font-corp text-color-base w-full pl-0 lg:pl-4 py-2">
                    <div className="flex items-center px-2">
                        <ImageAdaptive src={item.imgSrc} baseWidth={30} />
                    </div>
                    <div className="flex flex-shrink-0 items-center px-2 font-bold text-base text-xs lg:text-sm">
                        {item.title}
                    </div>
                    <div className="flex items-center font-notojp font-medium text-xs lg:text-sm text-color-base w-full pl-4 mb-1">
                        {item.description}
                    </div>
                </div>
            ))}
        </div>
    );
}
